<template>
  <a-card :bordered='false' class='card-area'>

    <!-- 查询区域 -->
    <div class='table-page-search-wrapper'>
      <!-- 搜索区域 -->
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>
          <a-col :md='6' :sm='8'>
            <a-form-item label='名称' :labelCol='{span: 5}' :wrapperCol='{span: 18, offset: 1}'>
              <a-input placeholder='请输入名称查询' v-model='queryParam.roleName'></a-input>
            </a-form-item>
          </a-col>
          <a-col :md='10' :sm='12'>
            <a-form-item label='创建时间' :labelCol='{span: 5}' :wrapperCol='{span: 18, offset: 1}'>
              <j-date v-model='queryParam.createTime_begin' :showTime='true' date-format='YYYY-MM-DD HH:mm:ss' style='width:45%' placeholder='请选择开始时间'></j-date>
              <span style='width: 10px;'>~</span>
              <j-date v-model='queryParam.createTime_end' :showTime='true' date-format='YYYY-MM-DD HH:mm:ss' style='width:45%' placeholder='请选择结束时间'></j-date>
            </a-form-item>
          </a-col>
          <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
            <a-col :md='6' :sm='24'>
              <a-button type='primary' @click='searchQuery'>{{ $t('button.search') }}</a-button>
              <a-button style='margin-left: 8px' @click='searchReset'>{{ $t('button.reset') }}</a-button>
            </a-col>
          </span>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class='table-operator' style='margin-top: 5px'>
      <a-button @click='handleAdd' type='primary' icon='plus'>{{ $t('button.add') }}</a-button>
      <a-button type='primary' icon='download' @click="handleExportXls('角色信息')">{{ $t('button.export') }}</a-button>
      <a-upload name='file' :showUploadList='false' :multiple='false' :headers='tokenHeader' :action='importExcelUrl' @change='handleImportExcel'>
        <a-button type='primary' icon='import'>{{ $t('button.import') }}</a-button>
      </a-upload>

      <a-dropdown v-if='selectedRowKeys.length > 0'>
        <a-menu slot='overlay'>
          <a-menu-item key='1' @click='batchDel'>
            <a-icon type='delete' />
            {{ $t('button.delete') }}
          </a-menu-item>
        </a-menu>
        <a-button style='margin-left: 8px'>
          {{ $t('button.batchOperation') }}
          <a-icon type='down' />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class='ant-alert ant-alert-info' style='margin-bottom: 16px;'>
        <i class='anticon anticon-info-circle ant-alert-icon'></i> {{ $t('tip.selected') }}&nbsp;<a style='font-weight: 600'>{{ selectedRowKeys.length }}</a>{{ $t('tip.term') }}&nbsp;&nbsp;
        <a style='margin-left: 24px' @click='onClearSelected'>{{ $t('button.clear') }}</a>
      </div>

      <a-table
        ref='table'
        size='middle'
        bordered
        rowKey='id'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='ipagination'
        :loading='loading'
        :rowSelection='{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}'
        @change='handleTableChange'>

        <span slot='action' slot-scope='text, record'>
          <a @click='handleEdit(record)'>{{ $t('button.edit') }}</a>
          <a-divider type='vertical' />

          <a-dropdown>
            <a class='ant-dropdown-link'>
              {{ $t('button.more') }} <a-icon type='down' />
            </a>
            <a-menu slot='overlay'>
              <a-menu-item>
                <a @click='handlePerssion(record.id)'>授权</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('tip.isDelete')" @confirm='() => handleDelete(record.id)'>
                  <a>{{ $t('button.delete') }}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>


      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <role-modal ref='modalForm' @ok='modalFormOk'></role-modal>
    <user-role-modal ref='modalUserRole'></user-role-modal>
  </a-card>
</template>

<script>
import RoleModal from './modules/RoleModal'
import UserRoleModal from './modules/UserRoleModal'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JDate from '@/components/jeecg/JDate'
import { MTC_AUTH } from '@api/servers'

export default {
  name: 'RoleList',
  mixins: [JeecgListMixin],
  components: {
    RoleModal,
    UserRoleModal,
    JDate
  },
  data(){
    return {

      description: '角色管理页面',
      // 查询条件
      queryParam: { roleName: '' },
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function( t, r, index ){
            return parseInt(index) + 1
          }
        },
        {
          title: '角色名称',
          align: 'center',
          dataIndex: 'roleName'
        },
        {
          title: '角色编码',
          align: 'center',
          dataIndex: 'roleCode'
        },
        {
          title: '备注',
          align: 'center',
          dataIndex: 'description'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          align: 'center',
          sorter: true
        },
        {
          title: '更新时间',
          dataIndex: 'updateTime',
          align: 'center',
          sorter: true
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: `${ MTC_AUTH }sys/role/list`,
        delete: `${ MTC_AUTH }sys/role/delete`,
        deleteBatch: `${ MTC_AUTH }sys/role/deleteBatch`,
        exportXlsUrl: `${ MTC_AUTH }sys/role/exportXls`,
        importExcelUrl: `${ MTC_AUTH }sys/role/importExcel`
      }
    }
  },
  computed: {
    importExcelUrl: function(){
      return `${ window._CONFIG[ 'domianURL' ] }/${ this.url.importExcelUrl }`
    }
  },
  methods: {
    handlePerssion: function( roleId ){
      // alert(roleId);
      this.$refs.modalUserRole.show(roleId)
    },
    onChangeDate( date, dateString ){
      console.log(date, dateString)
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less'
</style>